import config from '../config'
import AccessTokens from './accessTokens'
import Activity from './activity'
import Adjustment from './adjustment'
import AgentPipeline from './agentPipeline'
import ArcLive from './arcLive'
import AtlasLinks from './atlasLinks'
import AtlasAI from './atlasai'
import AuditLog from './auditLog'
import Auth from './auth'
import Bank from './bank'
import BankAccount from './bankAccount'
import BankTransactions from './bankTransactions'
import Bbc from './bbc'
import BBCLog from './bbcLog'
import Bdo from './bdo'
import Box from './box'
import Calendar from './calendar'
import CallSpeakers from './callSpeakers'
import Campaigns from './campaigns'
import CapTable from './capTable'
import CellNotes from './cellNotes'
import Channels from './channels'
import ApiClient from './client'
import ClientBanner from './clientBanner'
import ClientEmailGroups from './clientEmailGroups'
import ClientInfo from './clientInfo'
import ClientIntake from './clientIntake'
import Collection from './collection'
import Crm from './crm'
import CustomFields from './customFields'
import Dashboard from './dashboard'
import DueDiligence from './dueDiligence'
import DynamicEnvFeedback from './dynamicEnvFeedback'
import EntityInfo from './entityInfo'
import ErrorTriage from './errorTriage'
import ExternalApiKey from './externalApiKey'
import FboBankAccount from './fboBankAccount'
import Fee from './fee'
import Feedback from './feedback'
import File from './file'
import Flag from './flags'
import Frequency from './frequency'
import GeneralAnalysis from './generalAnalysis'
import GeneralLedger from './generalLedger'
import InterestRateTier from './interestRateTier'
import Lcr from './lcr'
import LegalApi from './legal'
import LegalEntities from './legalEntities'
import LoanBalance from './loanBalance'
import Logger from './logger'
import MarketIntelligence from './marketIntelligence'
import Mentions from './mentions'
import Messages from './messages'
import MyTasks from './myTasks'
import Newsfeed from './newsfeed'
import Notes from './notes'
import Notification from './notification'
import OngoingReporting from './ongoingReporting'
import Option from './option'
import OutgoingWire from './outgoingWire'
import Participant from './participant'
import PassThroughs from './passThroughs'
import Photo from './photo'
import Plaid from './plaid'
import Prospect from './prospect'
import PushSubscription from './pushSubscription'
import Qbo from './qbo'
import ReportingDocument from './reportingDocument'
import Reports from './reports'
import RequiredReport from './requiredReport'
import Salesforce from './salesforce'
import SavedFilters from './savedFilters'
import Search from './search'
import Sheets from './sheets'
import TaskProjects from './taskProjects'
import TaskRules from './taskRules'
import Teams from './teams'
import Treasury from './treasury'
import Twilio from './twilio'
import TwoFactorApi from './twoFactor'
import User from './user'
import VisualizationsTracking from './visualizationsTracking'

const apiClient: ApiClient = new ApiClient(config.apiPrefix)

export interface IApi {
  auth: Auth
  box: Box
  clientBanner: ClientBanner
  clientEmailGroups: ClientEmailGroups
  clientInfo: ClientInfo
  collection: Collection
  salesforce: Salesforce
  user: User
  bank: Bank
  bankAccount: BankAccount
  reportingDocument: ReportingDocument
  requiredReport: RequiredReport
  frequency: Frequency
  dashboard: Dashboard
  arcLive: ArcLive
  callSpeakers: CallSpeakers
  fee: Fee
  fboBankAccount: FboBankAccount
  adjustment: Adjustment
  interestRateTier: InterestRateTier
  loanBalance: LoanBalance
  passThroughs: PassThroughs
  outgoingWire: OutgoingWire
  activity: Activity
  bbc: Bbc
  auditLog: AuditLog
  file: File
  ongoingReporting: OngoingReporting
  client: ApiClient
  bankTransactions: BankTransactions
  capTable: CapTable
  lcr: Lcr
  prospect: Prospect
  generalLedger: GeneralLedger
  search: Search
  sheets: Sheets
  bdo: Bdo
  entityInfo: EntityInfo
  campaigns: Campaigns
  crm: Crm
  notes: Notes
  dueDiligence: DueDiligence
  clientIntake: ClientIntake
  notification: Notification
  calendar: Calendar
  newsfeed: Newsfeed
  participant: Participant
  bbcLog: BBCLog
  visualizationsTracking: VisualizationsTracking
  flag: Flag
  logger: Logger
  option: Option
  treasury: Treasury
  atlasAI: AtlasAI
  legal: LegalApi
  legalEntities: LegalEntities
  twoFactor: TwoFactorApi
  cellNotes: CellNotes
  channels: Channels
  messages: Messages
  marketIntelligence: MarketIntelligence
  mentions: Mentions
  atlasLinks: AtlasLinks
  myTasks: MyTasks
  taskProjects: TaskProjects
  taskRules: TaskRules
  customFields: CustomFields
  agentPipeline: AgentPipeline
  savedFilters: SavedFilters
  reports: Reports
  teams: Teams
  pushSubscription: PushSubscription
  generalAnalysis: GeneralAnalysis
  photo: Photo
  plaid: Plaid
  qbo: Qbo
  externalApiKey: ExternalApiKey
  accessTokens: AccessTokens
  feedback: Feedback
  dynamicEnvFeedback: DynamicEnvFeedback
  errorTriage: ErrorTriage
  twilio: Twilio
}

const apis = {
  auth: new Auth(apiClient),
  box: new Box(apiClient),
  collection: new Collection(apiClient),
  clientBanner: new ClientBanner(apiClient),
  clientEmailGroups: new ClientEmailGroups(apiClient),
  clientInfo: new ClientInfo(apiClient),
  salesforce: new Salesforce(apiClient),
  user: new User(apiClient),
  bank: new Bank(apiClient),
  bankAccount: new BankAccount(apiClient),
  reportingDocument: new ReportingDocument(apiClient),
  requiredReport: new RequiredReport(apiClient),
  frequency: new Frequency(apiClient),
  dashboard: new Dashboard(apiClient),
  arcLive: new ArcLive(apiClient),
  callSpeakers: new CallSpeakers(apiClient),
  fee: new Fee(apiClient),
  fboBankAccount: new FboBankAccount(apiClient),
  adjustment: new Adjustment(apiClient),
  interestRateTier: new InterestRateTier(apiClient),
  loanBalance: new LoanBalance(apiClient),
  passThroughs: new PassThroughs(apiClient),
  outgoingWire: new OutgoingWire(apiClient),
  activity: new Activity(apiClient),
  bbc: new Bbc(apiClient),
  auditLog: new AuditLog(apiClient),
  file: new File(apiClient),
  ongoingReporting: new OngoingReporting(apiClient),
  client: apiClient,
  bankTransactions: new BankTransactions(apiClient),
  capTable: new CapTable(apiClient),
  lcr: new Lcr(apiClient),
  prospect: new Prospect(apiClient),
  generalLedger: new GeneralLedger(apiClient),
  search: new Search(apiClient),
  sheets: new Sheets(apiClient),
  bdo: new Bdo(apiClient),
  entityInfo: new EntityInfo(apiClient),
  campaigns: new Campaigns(apiClient),
  crm: new Crm(apiClient),
  notes: new Notes(apiClient),
  dueDiligence: new DueDiligence(apiClient),
  clientIntake: new ClientIntake(apiClient),
  notification: new Notification(apiClient),
  calendar: new Calendar(apiClient),
  newsfeed: new Newsfeed(apiClient),
  participant: new Participant(apiClient),
  bbcLog: new BBCLog(apiClient),
  visualizationsTracking: new VisualizationsTracking(apiClient),
  flag: new Flag(apiClient),
  logger: new Logger(apiClient),
  option: new Option(apiClient),
  treasury: new Treasury(apiClient),
  atlasAI: new AtlasAI(apiClient),
  legal: new LegalApi(apiClient),
  legalEntities: new LegalEntities(apiClient),
  twoFactor: new TwoFactorApi(apiClient),
  cellNotes: new CellNotes(apiClient),
  channels: new Channels(apiClient),
  messages: new Messages(apiClient),
  marketIntelligence: new MarketIntelligence(apiClient),
  mentions: new Mentions(apiClient),
  atlasLinks: new AtlasLinks(apiClient),
  myTasks: new MyTasks(apiClient),
  taskProjects: new TaskProjects(apiClient),
  taskRules: new TaskRules(apiClient),
  customFields: new CustomFields(apiClient),
  agentPipeline: new AgentPipeline(apiClient),
  savedFilters: new SavedFilters(apiClient),
  reports: new Reports(apiClient),
  teams: new Teams(apiClient),
  pushSubscription: new PushSubscription(apiClient),
  generalAnalysis: new GeneralAnalysis(apiClient),
  photo: new Photo(apiClient),
  plaid: new Plaid(apiClient),
  qbo: new Qbo(apiClient),
  externalApiKey: new ExternalApiKey(apiClient),
  accessTokens: new AccessTokens(apiClient),
  feedback: new Feedback(apiClient),
  dynamicEnvFeedback: new DynamicEnvFeedback(apiClient),
  errorTriage: new ErrorTriage(apiClient),
  twilio: new Twilio(apiClient),
}

export default apis
